import { Card } from "@/components/ui/card";
import { UserPlus, Bell, TrendingUp, Award } from "lucide-react";
import { useTranslation } from "react-i18next";

const HowItWorks = () => {
  const { t } = useTranslation();
  
  const steps = [
    {
      icon: UserPlus,
      number: "01",
      title: "Sign Up in 60 Seconds",
      description: "Start your 7-day free trial — no credit card required. Instant access to all premium features."
    },
    {
      icon: Bell,
      number: "02",
      title: "Get Real-Time Signals",
      description: "Receive instant notifications for Bitcoin, Ethereum, altcoins, and futures from elite traders."
    },
    {
      icon: TrendingUp,
      number: "03",
      title: "Execute & Profit",
      description: "Follow detailed entry/exit points with professional risk management. Track your performance live."
    },
    {
      icon: Award,
      number: "04",
      title: "Join the Community",
      description: "Connect with fellow traders, share insights, and learn from experts in our active Discord."
    }
  ];

  return (
    <section className="py-20 relative overflow-hidden bg-secondary/10">
      <div className="container px-4">
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl md:text-5xl font-bold">
            How <span className="bg-gradient-primary bg-clip-text text-transparent">Oraculus:X</span> Works
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            From signup to profit in 4 simple steps — start winning with elite signals
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
          {steps.map((step, index) => (
            <Card 
              key={index}
              className="p-6 bg-card/40 backdrop-blur-xl border-border hover:border-primary/50 transition-all hover:scale-105 group relative"
            >
              <div className="absolute -top-4 -right-4 text-8xl font-bold text-primary/5 group-hover:text-primary/10 transition-all">
                {step.number}
              </div>
              <div className="relative z-10 space-y-4">
                <div className="flex items-center gap-4">
                  <div className="p-3 bg-gradient-primary rounded-lg group-hover:shadow-glow-primary transition-all">
                    <step.icon className="w-6 h-6" />
                  </div>
                  <span className="text-3xl font-bold text-primary">{step.number}</span>
                </div>
                <h3 className="text-xl font-bold">{step.title}</h3>
                <p className="text-muted-foreground leading-relaxed">{step.description}</p>
              </div>
              
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-8 transform -translate-y-1/2 z-20">
                  <div className="w-16 h-0.5 bg-gradient-to-r from-primary to-transparent" />
                </div>
              )}
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
